import * as vendorDetailsActions from './vendorDetails/actions';
import * as pageActions from './page/actions';
import * as eleFileConfig from './eleFileConfig/actions';

export const actions = {
  ...vendorDetailsActions,
  ...pageActions,
  ...eleFileConfig,
};



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/actions.js